import { render, staticRenderFns } from "./SettingPayAccount.vue?vue&type=template&id=afcb69b0&scoped=true"
import script from "./SettingPayAccount.vue?vue&type=script&lang=js"
export * from "./SettingPayAccount.vue?vue&type=script&lang=js"
import style0 from "./SettingPayAccount.vue?vue&type=style&index=0&id=afcb69b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcb69b0",
  null
  
)

export default component.exports